'use client';
import React, { FC } from 'react';
import type { Entry } from 'contentful';

import { MuxVideo } from '@/components/ui/MuxVideo';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { TypeVideoFields, TypeMuxVideoFields } from '@/core/generated-types';

interface VideoMuxSideBySideProps {
  mediaDesktop?: Entry<TypeVideoFields | TypeMuxVideoFields>;
  mediaMobile?: Entry<TypeVideoFields | TypeMuxVideoFields>;
}

export const MuxVideoSideBySide: FC<VideoMuxSideBySideProps> = ({
  mediaDesktop,
  mediaMobile,
}) => {
  const isDesktop = useIsDesktop();
  const media = isDesktop ? mediaDesktop : mediaMobile;
  const playbackId =
    media && (media.fields as TypeMuxVideoFields)?.muxVideoUpload?.playbackId;

  if (!playbackId) return null;

  const props = {
    title: media.fields.entryName || '',
    playbackId,
    autoplay: true,
  };

  return (
    <div className="lg:w-1/2 aspect-video lg:aspect-square xl:h-full relative">
      <MuxVideo {...props} />
    </div>
  );
};

export default MuxVideoSideBySide;
